<div class="mx-1 my-1">
  <div class="row my-row" *ngIf="patientForm">
    <div class="col-sm my-col">
      <div class="card mt-3">
        <div class="card-header">
          {{ "PATIENT.EDIT.TITLE-CREATE" | translate }}
        </div>
        <div class="card-body">
          <app-error
            [error_message]="errorMessage"
            [error_type]="errorType"
          ></app-error>

          <form
            *ngIf="patientForm"
            [formGroup]="patientForm"
            novalidate
            #formDirective="ngForm"
            (ngSubmit)="createPatient(patientForm.value)"
          >
            <div class="form-row mb-3 my-row">
              <div class="col-6 col-lg-auto pb-3 my-col">
                <mat-form-field class="mx-2">
                  <input
                    matInput
                    type="text"
                    placeholder="{{ 'FORM.FNAME' | translate }}"
                    formControlName="lname"
                    id="lname"
                  />
                  <mat-error *ngIf="hasError('lname', 'required')">{{
                    "ERRORS.FNAME-REQUIRED" | translate
                  }}</mat-error>
                  <mat-error *ngIf="hasError('lname', 'pattern')">{{
                    "ERRORS.FNAME-INVALID" | translate
                  }}</mat-error>
                </mat-form-field>

                <mat-form-field class="mx-2">
                  <input
                    matInput
                    type="text"
                    placeholder="{{ 'FORM.LNAME' | translate }}"
                    formControlName="fname"
                    id="fname"
                  />
                  <mat-error *ngIf="hasError('fname', 'required')">{{
                    "ERRORS.LNAME-REQUIRED" | translate
                  }}</mat-error>
                  <mat-error *ngIf="hasError('fname', 'pattern')">{{
                    "ERRORS.LNAME-INVALID" | translate
                  }}</mat-error>
                </mat-form-field>

                <mat-form-field class="mx-2">
                  <mat-label>{{ "FORM.BIRTHDATE" | translate }}</mat-label>
                  <input
                    matInput
                    readonly
                    formControlName="dateOfBirth"
                    (focus)="picker.open()"
                    id="dateOfBirth"
                    [max]="maxDate"
                    [matDatepicker]="picker"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="form-row mb-3 my-row">
              <div class="col-6 col-lg-auto pb-3 my-col">
                <mat-form-field class="mx-2">
                  <input
                    matInput
                    type="text"
                    placeholder="{{ 'FORM.MAIL' | translate }}"
                    formControlName="email"
                    id="email"
                  />
                  <mat-error *ngIf="hasError('email', 'required')">{{
                    "ERRORS.MAIL-REQUIRED" | translate
                  }}</mat-error>
                  <mat-error *ngIf="hasError('email', 'email')">{{
                    "ERRORS.MAIL-INVALID" | translate
                  }}</mat-error>
                  <mat-error *ngIf="hasError('email', 'pattern')">{{
                    "ERRORS.MAIL-INVALID" | translate
                  }}</mat-error>
                </mat-form-field>

                <mat-form-field class="mx-2">
                  <input
                    matInput
                    type="text"
                    placeholder="{{ 'FORM.CITY' | translate }}"
                    formControlName="city"
                    [matAutocomplete]="auto"
                    (blur)="checkCity()"
                  /><mat-error *ngIf="hasError('city', 'pattern')">{{
                    "ERRORS.CITY-INVALID" | translate
                  }}</mat-error>
                  <mat-autocomplete
                    autoActiveFirstOption
                    #auto="matAutocomplete"
                    (optionSelected)="cityClick($event)"
                  >
                    <mat-option
                      *ngFor="let city of filteredOptions | async"
                      [value]="city.nom"
                    >
                      {{ city.nom }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <mat-form-field *ngIf="patientForm.get('ins')" class="mx-2">
                  <input
                    matInput
                    type="text"
                    placeholder="{{ 'FORM.INS' | translate }}"
                    formControlName="ins"
                    id="ins"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="form-row mb-3 my-row">
              <div class="col-6 col-lg-auto pb-3 my-col">
                <mat-form-field class="mx-2">
                  <input
                    matInput
                    type="text"
                    placeholder="{{ 'FORM.PHONE' | translate }}"
                    formControlName="phoneNumber"
                    id="phoneNumber"
                  />
                  <mat-error *ngIf="hasError('phoneNumber', 'forbidden')">{{
                    "ERRORS.PHONE-INVALID" | translate
                  }}</mat-error>
                  <mat-error *ngIf="hasError('phoneNumber', 'required')">{{
                    "ERRORS.PHONE-REQUIRED" | translate
                  }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="form-row mb-3 my-row">
              <div class="col-6 col-lg-auto pb-3 my-col mx-2">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="consent"
                    formControlName="consent"
                  />
                  <label class="form-check-label" for="consent">{{
                    "FORM.CONSENT" | translate
                  }} *</label>
                </div>
              </div>
            </div>

            <div class="col-6 col-lg-auto pb-3 my-col">
              <p
                [innerHTML]="'FORM.REQUIRED-DATA' | translate"
                style="color: #f44336"
              ></p>
            </div>

            <div class="form-row pt-3 my-row">
              <div class="col my-col">
                <button
                  type="submit"
                  class="btn btn-primary mx-1"
                  [disabled]="!patientForm.valid"
                >
                  {{ "BUTTONS.ADD" | translate }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="row my-row">
    <div class="col-sm my-col">
      <div class="card mt-3">
        <div class="card-header">
          {{ "PATIENT.EDIT.TITLE-LOADPATIENT" | translate }}
        </div>
        <div class="card-body">
          <app-error
            [error_message]="errorMessageLoadPatient"
            [error_type]="errorTypeLoadPatient"
          ></app-error>
          <div class="row">
            <div class="col-sm">
              <div class="alert alert-success" role="alert">
                {{ "LOADPATIENT.TEXT-INFO" | translate }}
                <a
                  class="link-info font-weight-bold"
                  (click)="downloadLoadPatient()"
                >
                  {{ "LOADPATIENT.TEXT-INFO-LINK-LOADPATIENT" | translate }}
                </a>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-sm">
              <input
                type="file"
                #uploadFileInput
                id="fileUpload"
                name="fileUpload"
                accept=".xlsx"
                (change)="fileUpdate()"
              />
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-sm">
              <button
                [disabled]="!fileUpload"
                type="button"
                class="btn btn-primary"
                (click)="loadPatient(uploadFileInput)"
              >
                {{ "BUTTONS.LOADPATIENT" | translate }}
              </button>
            </div>
          </div>
          <div
            class="row mt-2"
            *ngIf="this.resSuccess.length > 0 || this.resError.length > 0"
          >
            <div class="col-sm" *ngIf="this.resSuccess.length > 0">
              <h3>{{ "LOADPATIENT.LIST-SUCCESS" | translate }}</h3>
              <ul>
                <li *ngFor="let success of this.resSuccess">
                  <p class="text-success">{{ success }}</p>
                </li>
              </ul>
            </div>
            <div class="col-sm" *ngIf="this.resError.length > 0">
              <h3>{{ "LOADPATIENT.LIST-ERRORS" | translate }}</h3>
              <ul>
                <li *ngFor="let error of this.resError">
                  <p class="text-danger">{{ error }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
